import React from 'react';
import styled from '@emotion/styled';
import { Icon } from '@components/common/generic-icon';
import { useI18NextContext } from '@components/hooks';
import { Icons } from '@model/common/icons';
import { BookingSteps } from '@model/common';
import { ThemeProps, DisableableThemeProps } from '@theme/base';

const Circle: any = styled.i(({ theme }: ThemeProps) => ({
  borderRadius: '50%',
  width: 18,
  height: 18,
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.2rem',
  fontWeight: 'bold',
  backgroundColor: theme.custom.colors.group5.base,
  textAlign: 'center',
  color: theme.custom.colors.white,
  display: 'inline-block',
  fontStyle: 'normal',
  flexShrink: 0
}));

interface ContainerProps extends DisableableThemeProps {
  isActive: boolean;
  isCompleted: boolean;
}
const Container: any = styled.div(({ theme, isActive, isDisabled, isCompleted }: ContainerProps) => {
  let color;
  let hoverColor;
  let backgroundColor;
  if (isDisabled) {
    color = theme.custom.colors.group4.lighter;
    hoverColor = theme.custom.colors.group4.lighter;
  } else if (isActive) {
    color = theme.custom.colors.group4.base;
    backgroundColor = theme.custom.colors.group1.base;
    hoverColor = theme.custom.colors.group1.dark;
  } else if (isCompleted) {
    color = theme.custom.colors.group2.base;
    hoverColor = theme.custom.colors.group2.dark;
  }
  return {
    transition: 'all 0.5s ease',
    color,
    display: 'flex',
    alignItems: 'center',
    ':hover': {
      color: hoverColor,
      i: {
        transition: 'all 0.5s ease',
        backgroundColor: hoverColor
      }
    },
    i: {
      backgroundColor: backgroundColor || color
    }
  };
});

const Label = styled.div(({ theme }: ThemeProps) => ({
  marginLeft: theme.custom.spacing.xSmall,
  ...(theme.custom.typography.labels.default as any),
  fontWeight: 'bold'
}));

const StyledIcon = styled(Icon)(({ theme }: ThemeProps) => ({
  fontSize: '1rem',
  color: theme.custom.colors.white
}));

export const StepperLabel = ({ label, disabled, active, completed, index }: any) => {
  const t: any = useI18NextContext();
  const isBackIcon: boolean = label === BookingSteps.SEARCH;
  const isNumberCircle: boolean = !isBackIcon && (disabled || active);
  const isCompleted: boolean = !isBackIcon && completed;
  return (
    <Container isActive={active} isDisabled={disabled} isCompleted={completed}>
      {isNumberCircle && <Circle>{index + 1}</Circle>}
      {isBackIcon && (
        <Circle>
          <StyledIcon name={Icons.ARROW_LEFT} />
        </Circle>
      )}
      {isCompleted && (
        <Circle>
          <StyledIcon name={Icons.CHECK} />
        </Circle>
      )}
      <Label>{t(label)}</Label>
    </Container>
  );
};
